import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '..';
import Role from '../../utils/interfaces/IRole';

export interface Root {
  role_id: number
  role: string
  related_roles: RelatedRole[]
  trajectory_id: number
}

export interface RelatedRole {
  role_id: number
  link_force: number
  role: string
}


type RelatedState = {
  relatedRole: {
    nodes: Role[];
    links: any[]
  }
  selectedRole?: any
  filterRole?: any
};

const initialState: RelatedState = {
  relatedRole: {
    nodes: [],
    links: []
  },
};

export const permission = createSlice({
  name: 'relatedRoles',
  initialState,
  reducers: {
    saveRelatedState: (state, action) => ({
      ...state,
      relatedRole: action.payload,
    }),
    setRoleInfo: (state, action) => ({
      ...state,
      selectedRole: action.payload,
    }),
    setFilterRole: (state, action) => ({
      ...state,
      filterRole: action.payload,
    }),

  },
});

/* istanbul ignore next */
export const stateRelatedRoles = (state: RootState): RelatedState => state.relatedRoles;
export const { saveRelatedState, setRoleInfo, setFilterRole } = permission.actions;
export default permission.reducer;
